import { SaleType } from '@wix/ambassador-premium-purchase-platform-v1-offering/types';
import { getMaxPricingDetailsDiscountPercent } from '@wix/package-picker-shared';
import { PremiumPurchasePlatformModule } from '@wix/premium-purchase-platform/@sdk';
import { EclipseOfferingApiClientContext } from '../eclipse-offering.context';
function hasDiscountInfo(response) {
  var _response$discount;
  return Boolean((_response$discount = response.discount) == null ? void 0 : _response$discount.discountInfo);
}
export const fetchOfferingDiscountQueryFn = async props => {
  const {
    httpClient
  } = props;
  const {
    getPurchaseDiscount,
    getPurchaseUserOffering
  } = PremiumPurchasePlatformModule.SDK.ApiClient.queries({
    httpClient
  });
  const p3Context = EclipseOfferingApiClientContext.get('p3Context');
  const isResellerOffering = EclipseOfferingApiClientContext.get('isResellerOffering');
  if (!p3Context) {
    throw new Error('P3 context is required to fetch offering discount');
  }
  const offeringData = await getPurchaseDiscount({
    ...p3Context
  });
  if (hasDiscountInfo(offeringData)) {
    return {
      ...offeringData,
      hasSale: true
    };
  }
  if (isResellerOffering) {
    var _offering$products;
    // reseller doesnt have discount info in the discount endpoint,
    // so we need to calculate the max discount percent from the products pricing.
    const offering = await getPurchaseUserOffering({
      ...p3Context
    });
    const resellerPercent = getMaxPricingDetailsDiscountPercent((_offering$products = offering.products) == null ? void 0 : _offering$products.flatMap(product => product.pricingDetails ?? []));
    if (resellerPercent !== undefined) {
      return {
        ...offeringData,
        hasSale: true,
        discount: {
          ...offeringData.discount,
          rate: `${resellerPercent}%`,
          discountInfo: {
            sale: {
              saleType: SaleType.SPECIAL_DISCOUNT
            }
          }
        }
      };
    } else {
      return {
        ...offeringData,
        hasSale: false
      };
    }
  }
  return {
    ...offeringData,
    hasSale: false
  };
};
//# sourceMappingURL=fetch-offering-discount.query.js.map